/**
 * Nanoleaf Theme — Global JavaScript
 * Native browser APIs only — no external dependencies
 */

/* ============================================================
   Cart API Utilities
   ============================================================ */

const CartAPI = {
  /**
   * Add item to cart via AJAX
   * @param {number} variantId
   * @param {number} quantity
   * @returns {Promise<Object>}
   */
  async add(variantId, quantity = 1) {
    const formData = new FormData();
    formData.append('id', variantId);
    formData.append('quantity', quantity);

    const response = await fetch('/cart/add.js', {
      method: 'POST',
      body: formData,
    });

    if (!response.ok) {
      const error = await response.json();
      throw new Error(error.description || 'Failed to add to cart');
    }

    const item = await response.json();
    document.dispatchEvent(new CustomEvent('cart:item-added', {
      detail: item,
      bubbles: true,
    }));

    return item;
  },

  /**
   * Get current cart state
   * @returns {Promise<Object>}
   */
  async get() {
    const response = await fetch('/cart.js');
    return response.json();
  },

  /**
   * Update item quantity
   * @param {string} key - Line item key
   * @param {number} quantity
   * @returns {Promise<Object>}
   */
  async update(key, quantity) {
    const response = await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity }),
    });

    if (!response.ok) throw new Error('Failed to update cart');

    const cart = await response.json();
    document.dispatchEvent(new CustomEvent('cart:updated', {
      detail: cart,
      bubbles: true,
    }));

    return cart;
  },
};

/* ============================================================
   Global Event Bus
   ============================================================ */

document.addEventListener('cart:item-added', () => {
  const countEl = document.querySelector('[data-cart-count]');
  if (countEl) {
    CartAPI.get().then((cart) => {
      countEl.textContent = cart.item_count;
    });
  }
});

/* ============================================================
   Dialog Auto-Close on Backdrop Click
   ============================================================ */

document.addEventListener('click', (event) => {
  if (event.target.tagName === 'DIALOG' && event.target.open) {
    const rect = event.target.getBoundingClientRect();
    const clickedInDialog =
      event.clientX >= rect.left &&
      event.clientX <= rect.right &&
      event.clientY >= rect.top &&
      event.clientY <= rect.bottom;

    if (!clickedInDialog) {
      event.target.close();
    }
  }
});
